import React, { Component } from 'react'
import { connect } from 'react-redux'
import './about-us.css';
import HomeBrands from '../../components/Home/home.brands';
import * as Actions from '../../store/actions';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';

export class AboutUs extends Component {

    componentDidMount() {
        const { updateWording } = this.props;
        updateWording();
    }

    render() {
        const { wording } = this.props;
        const { items } = wording.aboutUsPage;
        return (
            <div>

                <div>
                    <div className="background-img img-about-us-fullpage" style={{ backgroundImage: `url('${items[0].img}')` }} />
                    <div className="contain-about-us about-us-center">
                        <h1 className="title-paragraph">{items[0].title}</h1>
                        {
                            items[0].paragraph?.map((value, number) => (<p key={number}>{value}</p>))
                        }
                    </div>
                </div>

                <div className='container-about-us contain-about-us about-us-right'>
                    <div className='about-us-item-container flex vertical-center'>
                        <div className='background-img img-about-us' style={{ backgroundImage: `url('${items[1].img}')` }} />
                        <div className='text-about-us'>
                            <h1 className="title-paragraph">{items[1].title}</h1>
                            {
                                items[1].paragraph?.map((value, number) => (<p key={number}>{value}</p>))
                            }
                        </div>
                    </div>
                </div>

                <div className='container-about-us contain-about-us about-us-left'>
                    <div className='about-us-item-container flex vertical-stretch'>
                        <div className='text-about-us'>
                            <h1 className="title-paragraph">
                                {items[2].title[0]} <br />
                                {items[2].title[1]}
                            </h1>
                            {
                                items[2].paragraph?.map((value, number) => value ? (<p key={number}>{value}</p>): (<br key={number} />))
                            }
                        </div>
                        <div className='background-img img-about-us' style={{ backgroundImage: `url('${items[2].img}')` }} />
                    </div>
                </div>

                <div>
                    <div className="background-img img-about-us-fullpage" style={{ backgroundImage: `url('${items[3].img}')`, backgroundPosition: "0px -25vw" }} />
                    <div className="contain-about-us about-us-center">
                        <h1 className="title-paragraph">{items[3].title}</h1>
                        {
                            items[3].paragraph?.map((value, number) => typeof value === "string" 
                                ? (<p key={number}>{value}</p>)
                                : (
                                    <p key={number}>
                                        {value.text}
                                        {
                                            value.tag.tagName === "Link" 
                                                ? <Link {...value.tag.props}>{value.tag.text}</Link>
                                                : React.createElement(value.tag.tagName, value.tag.props, value.tag.text)
                                        }
                                    </p>
                                )
                            )
                        }
                    </div>
                </div>

                <HomeBrands />
            </div>
        )
    }
}

const mapStateToProps = ({ language }) => ({
    wording: language.wording
});
const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            updateWording: Actions.updateWording
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(AboutUs);
